type ResourcePointHeritageMarkdownFieldProps = {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  ariaLabel?: string;
};

/** 传承人文案：纯文本编辑（保存后详情按 Markdown 渲染）。 */
export function ResourcePointHeritageMarkdownField({
  value,
  onChange,
  error,
  placeholder = "请输入传承人介绍，支持 Markdown 格式",
  ariaLabel = "传承人文案",
}: ResourcePointHeritageMarkdownFieldProps) {
  const errorId = error ? `${ariaLabel}-error` : undefined;

  return (
    <section className="resource-point-heritage-markdown-editor" data-testid="heritage-markdown-editor">
      <textarea
        className="resource-point-heritage-markdown-editor__textarea"
        aria-label={ariaLabel}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      {error ? (
        <div id={errorId} className="resource-point-form-error" role="alert">{error}</div>
      ) : null}
    </section>
  );
}
